<template>
  <m-field
    :data-testid="testId"
    :status="hasError ? 'danger' : 'default'"
    class="switch"
    :class="`switch-${$.uid}`">
    <m-switch
      :checked="lazyValue"
      v-bind="$attrs"
      @change="event => (internalValue = event.target.checked)">
      <span>
        {{ label }}

        <help-tooltip v-if="hint" :text="hint" />
      </span>
    </m-switch>
    <m-field-hint :data-testid="`${testId}-errors`">
      <span>{{ errorBucket.join(', ') }}</span>
      <span v-if="errorBucket.length && hint">.</span>
      <span v-if="hint" :class="{ 'p-l-1': errorBucket.length }">{{ hint }}</span>
    </m-field-hint>
  </m-field>
</template>

<script>
import fieldMixin from '@/components/mixins/fieldMixin';
import validatable from '@/components/mixins/validatable';
import testable from '@/components/mixins/testable';
import { HelpTooltip } from '@/components';

export default {
  mixins: [fieldMixin, validatable, testable],
  components: { HelpTooltip },
  props: {
    /**
     * @model
     */
    modelValue: {
      type: Boolean,
      required: false
    }
  }
};
</script>

<style lang="scss" scoped>
m-field {
  display: inline-flex;
}
m-switch {
  min-height: 25px;
  height: auto;
}
</style>
